
<template>
  <v-layout row justify-center>
    <v-card min-width="360px" class="mt-16 rounded-xl" :loading="loading">
      <v-card-title class="d-flex justify-center">
        <span> Смена пароля </span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex>
              <form class="px-4">
                <v-text-field
                  label="E-mail"
                  v-model="email"
                  :error-messages="emailErrors"
                  @input="$v.email.$touch()"
                  autocomplete
                  autofocus
                  required
                ></v-text-field>

                <v-btn
                  color="light-blue lighten-4"
                  block
                  class="text-none subtitle-1 mb-4 mt-3"
                  :disabled="this.$v.$invalid"
                  :loading="loading"
                  :disable="loading"
                  @click.stop="showDialog = true"
                  @click="submit"
                >
                  Отправить
                </v-btn>
              </form>
              <confirm-dialog v-model="showDialog"></confirm-dialog>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-layout>
</template>


<script>
import auth from "../config/auth";
import ConfirmDialog from "./ConfirmDialog.vue";
import { required, email } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
  components: {
    ConfirmDialog,
  },
  mixins: [validationMixin],

  validations: {
    email: {
      // async isUnique(value) {
      //   // console.log("value: " + value);
      //   // if (value === "") return true;
      //   const response = await axios.post(this.url, { email: value });
      //   return Boolean(await response.result);
      // },
      required,
      email,
      isUnique(value) {
        if (value === "") return true;
        this.checkingUsername = true;

        return auth
          .post(this.check_url, { email: this.email })
          .then((response) => {
            console.log(response);
            this.checkingUsername = false;
            return !response.data.result;
          })
          .catch(() => {
            return true;
          });
      },
    },
  },

  data: () => ({
    email: "",
    check_url: "/auth/check_email_unique/",
    url: "/auth/users/reset_password/",
    loading: false,
    showDialog: false,
  }),

  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      const email_regex = !this.$v.email.email;
      const email_required = !this.$v.email.required;
      email_regex && errors.push("Введёный адрес не является e-mail");
      email_required && errors.push("E-mail - обязательное поле");
      if (!email_regex && !email_required) {
        !this.$v.email.isUnique &&
          errors.push("Данный E-mail не зарегистрирован");
      }
      // console.log("errors: " + errors);
      return errors;
    },
  },

  methods: {
    submit: function () {
      this.$v.$touch();

      this.loading = true;

      console.log("loading:" + this.loading);
      auth
        .post(this.url, { email: this.email })
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
      this.loading = false;
      console.log("loading disabled:" + this.loading);
      this.$store.dispatch({ type: "setConfirmDialog", value: true });
    },
  },
};
</script>